// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"author-details-m__wrapper__1fuk_","author-bio":"author-details-m__author-bio__1B9ya","alumnus":"author-details-m__alumnus__1bctx"};